"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMovingState = exports.assetToTranslation = exports.assetToIcon = exports.AssetIcon = void 0;

var _react = _interopRequireDefault(require("react"));

var _types = require("@nicbase/types");

var _assetIcon = _interopRequireDefault(require("./asset-icon"));

var _assetTranslation = _interopRequireDefault(require("./asset-translation"));

var _excluded = ["type", "status"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var assetToTranslation = function assetToTranslation(assetType) {
  if (!assetType) return 'widgets.details.assetType.UNDEFINED';
  return _assetTranslation["default"][assetType] || 'widgets.details.assetType.UNDEFINED';
};

exports.assetToTranslation = assetToTranslation;

var getMovingState = function getMovingState(status) {
  if (status.includes(_types.LatestDataSimpleStatusType.Driving)) {
    return _types.LatestDataSimpleStatusType.Driving;
  }

  if (status.includes(_types.LatestDataSimpleStatusType.Standing)) {
    return _types.LatestDataSimpleStatusType.Standing;
  }

  return 'DEFAULT';
};

exports.getMovingState = getMovingState;

var assetToIcon = function assetToIcon(assetType) {
  var status = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'DEFAULT';
  if (!assetType) return null;
  var moveState;

  if (Array.isArray(status)) {
    moveState = getMovingState(status);
  } else {
    moveState = status;
  }

  var icon;

  try {
    icon = _assetIcon["default"][assetType][moveState];

    if (icon === undefined) {
      throw new TypeError("Asset mapping - missing icon for', ".concat(assetType, ", ").concat(moveState));
    }
  } catch (e) {
    console.error(e.message);
    icon = null;
  }

  return icon;
};

exports.assetToIcon = assetToIcon;

var AssetIcon = function AssetIcon(_ref) {
  var type = _ref.type,
      status = _ref.status,
      other = _objectWithoutProperties(_ref, _excluded);

  var Icon = assetToIcon(type, status);

  if (!Icon) {
    return null;
  }

  return /*#__PURE__*/_react["default"].createElement(Icon, other);
};

exports.AssetIcon = AssetIcon;
AssetIcon.defaultProps = {
  status: 'DEFAULT',
  className: null,
  style: null
};